module.exports = __webpack_public_path__ + "img/Jhanvi Shah, Co-Director of SIF, Schulich Finance Association.ef2b2e17.webp";